import { jaxa } from '../../App';
import Swal from 'sweetalert2';
import { DateFormatt } from '../../functions';
import { Chip, IconButton } from '@mui/material';
import { DownloadRounded } from '@mui/icons-material';

function renderStatus(status) {

    const colors = {
        complete: 'success', 
        incomplete: 'error', 
    };

    const label = {
        complete: 'Paid', 
        incomplete: 'Unpaid', 
    };

    return <Chip label={label[status]} color={colors[status]} size="small" />;

};

const downloadInvoice = async(id) => {
    await jaxa.get('/create-invoice-report', {
        params: {
            invoiceId: id, 
        },
        responseType: 'blob', 
    }).then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Invoice.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
    }).catch((e) => {
        Swal.fire({ title: 'Failed to create invoice' });
        console.log(`Error: ${e}`);
    });
};

function renderDate(value){
    const val = DateFormatt(value);
    return <Chip label={val} color='default' size="small" />;
};

function renderButton(id){
    return (
        <IconButton onClick={() => downloadInvoice(id)} sx={{ height: 30, width: 30 }}>
            <DownloadRounded/>
        </IconButton>
    );
};

export const columns = [
    {
        field: "serial-number",
        headerName: "#",
        filterable: false,
        renderCell: (params) => params.api.getAllRowIds().indexOf(params.id)+1,
        minWidth: 20
    },
    { 
        field: 'desc', 
        headerName: 'Description', 
        flex: 1.5, 
        minWidth: 200 
    },
    {
        field: 'qty',
        headerName: 'Quantity',
        headerAlign: 'left',
        align: 'left',
        flex: 1,
        minWidth: 100,
    },
    {
        field: 'unitprice',
        headerName: 'Unit Price',
        headerAlign: 'left',
        align: 'left',
        flex: 1,
        minWidth: 80,
    },
    {
        field: 'amount',
        headerName: 'Amount',
        headerAlign: 'left',
        align: 'left',
        flex: 1,
        minWidth: 100,
    },
    {
        field: 'taxRate',
        headerName: 'Tax Rate',
        headerAlign: 'left',
        align: 'left',
        flex: 1,
        minWidth: 100,
    },
    {
        field: 'taxAmount',
        headerName: 'Tax Amount',
        headerAlign: 'left',
        align: 'left',
        flex: 1,
        minWidth: 100,
    },
    {
        field: 'netAmount',
        headerName: 'Net Amount',
        headerAlign: 'left',
        align: 'left',
        flex: 1,
        minWidth: 100,
    },
];

export const columns2 = [
    {
        field: "serial-number",
        headerName: "#",
        filterable: false,
        renderCell: (params) => params.api.getAllRowIds().indexOf(params.id)+1,
        minWidth: 20
    },
    { 
        field: 'name', 
        headerName: 'Name', 
        flex: 1.5, 
        minWidth: 200 
    },
    {
        field: 'invoiceNo',
        headerName: 'Invoice Number',
        headerAlign: 'left',
        align: 'left',
        flex: 1,
        minWidth: 100,
    },
    {
        field: 'total',
        headerName: 'Invoice Amount',
        headerAlign: 'left',
        align: 'left',
        flex: 1,
        minWidth: 100,
    },
    {
        field: 'invoiceDate',
        headerName: 'Invoice Date',
        headerAlign: 'left',
        align: 'left',
        flex: 1,
        minWidth: 80,
        renderCell: (params) => renderDate(params.value),
    },
    { 
        field: 'status', 
        headerName: 'Status', 
        headerAlign: 'center',
        align: 'center',
        renderCell: (params) => renderStatus(params.value),
    },
    {
        field: 'download',
        headerName: 'Download',
        headerAlign: 'left',
        align: 'center',
        renderCell: (params) => renderButton(params.id),
    },
];